<template>
  <div>
    <vs-row>
      <vs-col
        vs-offset="1" vs-lg="11" vs-type="flex" class="pt-2 border-top"
      >
        <vs-chip class="mr-4" v-tooltip="'Próxima facturación'">
          <vs-avatar icon="date_range" />
          {{ '2022' + '-' + '10' + '-' + file.configuracion.day | dateFormat }}
        </vs-chip>
        <vs-chip
          class="mr-3"
          v-tooltip="'Estado de facturación'"
        >
          <vs-avatar
            :icon="file.estado ? 'check' : 'do_not_disturb'"
            :color="file.estado ? '#43C3B9' : '#DB1D2A'"
          />
          {{file.estado ? 'Activo' : 'Inactivo'}}
        </vs-chip>
      </vs-col>
    </vs-row>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';

export default {
  data() {
    return {
      dataDueDate: true
    };
  },
  props: [
    'file'
  ],
  computed: {
    ...mapGetters('Usuario', ['currentUserId']),
    ...mapGetters('Empresas', ['company'])
  }
};
</script>
